// extracted by mini-css-extract-plugin
export var cardHeader = "_tp-0";
export var reorderHandle = "_tp-3";
export var titleArea = "_tp-1";
export var titleAreaWithHandle = "_tp-2";